import { PersistConfig } from 'redux-persist';
import sessionStorage from 'redux-persist/lib/storage/session';

import { RootState } from 'app/redux/state/root-state';
import { AuthState } from 'app/pages/auth/redux/auth-state';

const rootPersistConfig: PersistConfig<RootState> = {
    key: 'wifiOveralt.root',
    storage: sessionStorage,
    blacklist: ['router', 'auth'],
};

const authPersistConfig: PersistConfig<AuthState> = {
    key: 'wifiOveralt.auth',
    storage: sessionStorage,
    blacklist: ['failed'],
};

export { rootPersistConfig, authPersistConfig };
